export function getMenuItemSubtitle(
  kind: "collection" | "note",
  metadata?: Record<string, unknown>,
  showMetadata: boolean = true
): string | undefined {
  if (!showMetadata) return undefined;

  const isCollection = kind === "collection";
  const isNote = kind === "note";
  const noteCount = metadata?.noteCount as number | undefined;
  const dateLabel = metadata?.dateLabel as string | undefined;
  const description = metadata?.description as string | undefined;

  const metadataItems = [];

  if (isCollection && typeof noteCount === "number") {
    const subtitle = getCollectionMenuItemSubtitle(noteCount, description);
    if (subtitle) metadataItems.push(subtitle);
  }

  if (isNote && dateLabel) {
    metadataItems.push(dateLabel);
  }

  return metadataItems.join(" • ") || undefined;
}

export const getCollectionMenuItemSubtitle = (
  noteCount: number,
  description?: string
): string | null => {
  if (noteCount === 0) {
    if (description) {
      return description;
    }

    return "No notes";
  }

  const countText = `${noteCount} ${noteCount === 1 ? "note" : "notes"}`;
  if (!description) {
    return countText;
  }

  return `${countText} • ${description}`;
};
